module.exports = __webpack_public_path__ + "img/coins.d38088d6.svg";